import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckByStatusListController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckByStatusListController.php
* @route '/api/fetch-checks-by-status'
*/
const GetCheckByStatusListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCheckByStatusListController.url(options),
    method: 'get',
})

GetCheckByStatusListController.definition = {
    methods: ["get","head"],
    url: '/api/fetch-checks-by-status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckByStatusListController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckByStatusListController.php
* @route '/api/fetch-checks-by-status'
*/
GetCheckByStatusListController.url = (options?: RouteQueryOptions) => {
    return GetCheckByStatusListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckByStatusListController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckByStatusListController.php
* @route '/api/fetch-checks-by-status'
*/
GetCheckByStatusListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCheckByStatusListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckByStatusListController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckByStatusListController.php
* @route '/api/fetch-checks-by-status'
*/
GetCheckByStatusListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCheckByStatusListController.url(options),
    method: 'head',
})

export default GetCheckByStatusListController